@if (showComponent()) {
    <div class="container-fluid well">
        <h5>{{title}}</h5>
        <h6>Please enter any notations that are pertinent to the survey method and plan, or conveyancing outcome of the plan</h6>
        <div class="row">
            <div class="col-xs-4">
                <label
                    class="control-label"
                    for="surveyPlanNotation">
                    {{surveyAndPlanNotificationTitle}}
                </label>
                <div
                    class="input-group"
                    [ngClass]="{'has-error': surveyPlanNotation | formFieldHasError}">
                    <span class="input-group-addon corner">
                        <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                    </span>
                    <textarea
                        class="form-control"
                        name="surveyPlanNotation"
                        id="surveyPlanNotation"
                        placeholder="Enter {{surveyAndPlanNotificationTitle}}"
                        rows="4"
                        cols="60"
                        title="Enter {{surveyAndPlanNotificationTitle}}"
                        [maxlength]="1000"
                        [disabled]="!hasEditPermission()"
                        [(ngModel)]="getCertification().surveyPlanNotation"
                        #surveyPlanNotation="ngModel">
                    </textarea>
                </div>
            </div>
            @if (getAcquisitionActionStatement()) {
                <div class="col-xs-4">
                    <label class="control-label">{{acquisitionActionStatementTitle}}</label>
                    <div class="input-group">
                        <textarea
                            class="form-control"
                            name="acquisitionActionStatement"
                            rows="4"
                            cols="60"
                            readonly
                            [ngModel]="getAcquisitionActionStatement()">
                        </textarea>
                    </div>
                </div>
            }
            @if (getTransferActionStatement()) {
                <div class="col-xs-4">
                    <label class="control-label">{{transferActionStatementTitle}}</label>
                    <div class="input-group">
                        <textarea
                            class="form-control"
                            name="transferActionStatement"
                            rows="4"
                            cols="60"
                            readonly
                            [ngModel]="getTransferActionStatement()">
                        </textarea>
                    </div>
                </div>
            }
        </div>
    </div>
}
